import {CommonModule} from '@angular/common';
import {
  Component,
  ContentChild,
  inject,
  Input,
  OnInit,
  TemplateRef,
} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
  ControlContainer,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {
  Condition,
  LogicalOperator,
} from '@em/shared/mapping-engine/domain-models';
import {EmButtonModule} from '@em/shared/ui';
import {MappingEngineFormBuilderService} from '../../services/mapping-engine-form-builder/mapping-engine-form-builder.service';

@Component({
  selector: 'em-conditional-statement',
  templateUrl: './conditional-statement.component.html',
  styleUrls: [
    './conditional-statement.component.scss',
    '../../styles/mapping-engine.scss',
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    EmButtonModule,
  ],
})
export class EmConditionalStatementComponent implements OnInit {
  private readonly _controlContainer = inject(ControlContainer);
  private readonly _ME_fb = inject(MappingEngineFormBuilderService);

  @ContentChild(TemplateRef) template!: TemplateRef<unknown>;
  @Input() availableOperators: LogicalOperator[] | undefined | null;
  @Input() canDelete = true;

  formGroup: UntypedFormGroup | null | undefined;

  get conditionsFormArray(): UntypedFormArray {
    return this.formGroup?.get('conditions') as UntypedFormArray;
  }

  get logicalOperatorControl(): UntypedFormControl {
    return this.formGroup?.get('logicalOperator') as UntypedFormControl;
  }

  ngOnInit(): void {
    this.formGroup = this._controlContainer.control as UntypedFormGroup;
  }

  addNewCondition(logicalOperator: LogicalOperator | undefined) {
    if (!this.logicalOperatorControl.value && logicalOperator) {
      this.logicalOperatorControl.setValue(logicalOperator);
    }

    this._ME_fb.addCondition({} as Condition, this.conditionsFormArray);
  }

  removeCondition(index: number) {
    this.conditionsFormArray.removeAt(index);
    if (this.conditionsFormArray.controls.length <= 1) {
      this.logicalOperatorControl.setValue(null);
    }
  }
}
